export type Font = {
  fontFamily: string
  fontStyle: string
  fontDisplay: string
  fontWeight: number
  src: string
}

export type FontList = Record<
  string,
  {
    name: string
    embedded: boolean
    order: number
  }
>

export const sofiaProMedium = {
  fontFamily: 'SofiaPro-Medium',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    url('https://assets.alphamap.com/fonts/SofiaProMedium/font.woff2') format('woff2'), url('https://assets.alphamap.com/fonts/SofiaProMedium/font.woff') format('woff') 
  `,
}

export const sofiaProSemiBold = {
  fontFamily: 'SofiaPro-SemiBold',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: `
    url('https://assets.alphamap.com/fonts/SofiaProSemiBold/font.woff2') format('woff2'), url('https://assets.alphamap.com/fonts/SofiaProSemiBold/font.woff') format('woff') 
  `,
}

export const generateFontFace = (font: Font) => {
  return `
    @font-face {
      font-family: ${font.fontFamily};
      font-style: ${font.fontStyle};
      font-display: ${font.fontDisplay};
      font-weight: ${font.fontWeight};
      src: ${font.src};
    }
  `
}

export const REPORT_GOOGLE_FONTS_URL = 'https://www.googleapis.com/webfonts/v1/webfonts'
export const REPORT_GOOGLE_FONTS_KEY = 'AIzaSyBPs2M9d-thCGskfQ70lpuUPYwUWx5djsM'
export const REPORT_DEFAULT_FONT_SIZE = 16
export const REPORT_DEFAULT_FONT_OPTIONS = [10, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96]
export const REPORT_DEFAULT_FONT_COLOR = '#000000'
export const REPORT_DEFAULT_FONT_FAMILY = 'SofiaPro-Medium'

export const REPORT_FONT_LIST: FontList = {
  // Embedded 3Party Fonts
  'alphamap-a': {
    name: 'Arial',
    embedded: true,
    order: 1,
  },
  'alphamap-b': {
    name: 'Times New Roman',
    embedded: true,
    order: 2,
  },
  'alphamap-c': {
    name: 'Calibri',
    embedded: true,
    order: 3,
  },
  'alphamap-d': {
    name: 'Verdana',
    embedded: true,
    order: 4,
  },
  'alphamap-e': {
    name: 'Helvetica',
    embedded: true,
    order: 5,
  },
  'alphamap-f': {
    name: 'Comic Sans',
    embedded: true,
    order: 6,
  },
  // Google Fonts
  'Open Sans': {
    name: 'Open Sans',
    embedded: false,
    order: 7,
  },
  'Bebas Neue': {
    name: 'Bebas Neue',
    embedded: false,
    order: 8,
  },
  Charm: {
    name: 'Charm',
    embedded: false,
    order: 9,
  },
  Inconsolata: {
    name: 'Inconsolata',
    embedded: false,
    order: 10,
  },
  'Indie Flower': {
    name: 'Indie Flower',
    embedded: false,
    order: 11,
  },
  Merriweather: {
    name: 'Merriweather',
    embedded: false,
    order: 12,
  },
  Roboto: {
    name: 'Roboto',
    embedded: false,
    order: 13,
  },
  Montserrat: {
    name: 'Montserrat',
    embedded: false,
    order: 14,
  },
  Poppins: {
    name: 'Poppins',
    embedded: false,
    order: 15,
  },
  'EB Garamond': {
    name: 'Garamond',
    embedded: false,
    order: 16,
  },
  'Libre Baskerville': {
    name: 'Baskerville',
    embedded: false,
    order: 17,
  },
  'Libre Franklin': {
    name: 'Franklin',
    embedded: false,
    order: 18,
  },
  'Libre Bodoni': {
    name: 'Bodoni',
    embedded: false,
    order: 19,
  },
  'Dancing Script': {
    name: 'Dancing Script',
    embedded: false,
    order: 20,
  },
  'Courier Prime': {
    name: 'Courier',
    embedded: false,
    order: 21,
  },
  'SofiaPro-Medium': {
    name: 'Sofia Pro',
    embedded: false,
    order: 22,
  },
}

export const reportEditorEmbeddedFonts = () => {
  return Object.keys(REPORT_FONT_LIST).reduce((out, font) => {
    if (REPORT_FONT_LIST[font].embedded) {
      out += generateFontFace({
        fontFamily: font,
        fontStyle: 'normal',
        fontDisplay: 'swap',
        fontWeight: 400,
        src: `url('https://assets.alphamap.com/fonts/Extra/${font}.woff2') format('woff2')`,
      })
    }
    return out
  }, '')
}
